import { LitElement, html, css } from 'lit-element';
import { FBP } from '@furo/fbp';
// import {i18n} from "@furo/framework";

import '@furo/data/src/furo-data-object.js';
import '@furo/data/src/furo-entity-agent.js';

import '@furo/data-input/src/furo-catalog.js';
import '@furo/data-input/src/furo-data-collection-dropdown.js';
import '@furo/form/src/furo-catalog.js';

import './make-empty-ersatzteil-object.js';
import '../../project-components/detail-button-bar.js';
import './ers-detail-form.js';

/**
 * `ers-detail`
 * Describe your element
 *
 * @summary shortdescription
 * @customElement
 * @demo demo/ers-detail.html
 * @appliesMixin FBP
 */
class ErsDetail extends FBP(LitElement) {
  /**
   * Exposes --queryParams
   * @param {Object} det
   */
  setQp(det) {
    // setze auf edit wenn wir spc und arb haben
    this._FBPTriggerWire('--queryParams', det);
    // setze auf neu erstellen wenn wir nur sco haben

    if (det.est === undefined) {
      this._FBPTriggerWire('--creatorQP', det);
    } else {
      this._FBPTriggerWire('--editQP', det);
    }
    // wir müssen nach dem delete nur den QP SPC schicken, damit est verschwindet
    this.createNewQP = { spc: det.spc };
  }

  addClicked(e) {
    this._FBPTriggerWire('--addClicked', e);
  }

  /**
   * flow is ready lifecycle method
   */
  _FBPReady() {
    super._FBPReady();
    // this._FBPTraceWires();
  }

  /**
   * @private
   * @returns {TemplateResult}
   */
  render() {
    // language=HTML
    return html`
      <furo-vertical-flex style="position: relative">
        <furo-banner-display autofocus=""></furo-banner-display>
        <furo-banner ƒ-parse-grpc-status="--error" icon="warning"></furo-banner>

        <ers-detail-form
          flex
          scroll
          ƒ-set-qp="--queryParams"
          ƒ-bind-data="--entityReady(*.data)"
          ƒ-object-collection-in="--objekteResponse"
          ƒ-raw-lagerorte-collection-in="--LagerortResponse"
          ƒ-start-activity="--saveClicked, --createClicked"
          ƒ-stop-activity="--dataLoaded, --saveSuccess, --emptyObject, --createSuccess, --error"
        >
        </ers-detail-form>

        <furo-ripple noink class="success" ƒ-trigger="--saveSuccess, --createSuccess"></furo-ripple>
        <detail-button-bar
          ƒ-bind-entity="--entityReady"
          @-save-clicked="--saveClicked"
          @-create-clicked="--createClicked"
          @-delete-clicked="--deleteClicked"
        >
        </detail-button-bar>
      </furo-vertical-flex>

      <!-- Ab hier die datenlogik-->
      <furo-deep-link
        service="Ersatzteil"
        ƒ-qp-in="--queryParams, --createdQp"
        @-hts-out="--hts"
      ></furo-deep-link>

      <make-empty-ersatzteil-object
        ƒ-qp-in="--creatorQP"
        ƒ-trigger-custom-method="--addClicked, --createSuccess"
        @-object-created="--emptyObject"
      ></make-empty-ersatzteil-object>

      <furo-entity-agent
        service="Ersatzteil"
        ƒ-hts-in="--hts"
        ƒ-load="--editQP"
        ƒ-bind-request-data="--entityReady(*.data)"
        ƒ-delete="--deleteClicked"
        @-delete-success="^^ersatzteil-deleted(createNewQP)"
        @-save-success="--saveSuccess, ^^ersatzteil-saved"
        @-create-success="--createSuccess, ^^ersatzteil-created(createNewQP), --createdQp(createNewQP)"
        ƒ-save="--saveClicked, --createClicked"
        @-load-success="--dataLoaded"
        @-response-error="--error"
      ></furo-entity-agent>

      <furo-data-object
        type="ersatzteil.ErsatzteilEntity"
        ƒ-clear-all-errors="--dataLoaded, --saveSuccess, --emptyObject, --createSuccess"
        ƒ-inject-raw="--dataLoaded, --saveSuccess, --emptyObject"
        @-object-ready="--entityReady"
      ></furo-data-object>

      <furo-deep-link
        service="Supportcaseobject"
        ƒ-qp-in="--queryParams"
        @-hts-out="--htsObjekte"
      ></furo-deep-link>

      <furo-collection-agent
        service="Supportcaseobject"
        ƒ-hts-in="--htsObjekte"
        list-on-hts-in
        @-response="--objekteResponse"
      ></furo-collection-agent>

      <furo-deep-link
        service="Lagerort"
        ƒ-qp-in="--queryParams"
        @-hts-out="--htsLagerort"
      ></furo-deep-link>

      <furo-collection-agent
        service="Lagerort"
        ƒ-hts-in="--htsLagerort"
        list-on-hts-in
        @-response="--LagerortResponse"
      ></furo-collection-agent>
    `;
  }

  /**
   *
   * @private
   * @return {CSSResult}
   */
  static get styles() {
    // language=CSS
    return css`
      :host {
        display: block;
        background-color: var(--surface, white);
        font-size: 14px;
        padding: 12px 24px;
        height: 100%;
        box-sizing: border-box;
      }

      furo-ripple.success {
        --furo-ripple-bg-color: var(--success, #5ef47f);
      }

      furo-banner-display {
        --furo-icon-fill-color: var(--danger, red);
      }
      ers-detail-form {
        margin-top: 12px;
      }
    `;
  }
}

window.customElements.define('ers-detail', ErsDetail);
